import React, { PropTypes, Component } from 'react'
import cx from 'classnames'
import { Link } from 'react-router'

import './ChangeAliadaConfirmBase.scss'
import ProfileMobileNavBar from 'components/ProfileMobileNavBar'
import ModifyingServiceLoader from 'components/ModifyingServiceLoader'
import ChangingAliadasAvatars from './components/ChangingAliadasAvatars'
import ChangeSummary from './components/ChangeSummary'
import { serviceTypes } from '@src/globals'
import * as paths from 'utils/paths'

class ChangeAliadaConfirmBase extends Component {
  constructor (props) {
    super(props)

    this.state = {
      penaltyFetched: false
    }

    this.navBarLabel = ' ' // Override this property

    this.cancelChange = this.cancelChange.bind(this)
    this.changeAliadas = this.changeAliadas.bind(this)
    this.onPenaltyFetched = this.onPenaltyFetched.bind(this)
  }

  componentDidMount () {
    const { bookingId, replacementAliadaId } = this.props
    this.fetchBooking(bookingId)
    this.fetchAliada(replacementAliadaId)
  }

  fetchBooking (id) {
    this.props.fetchBooking(id)
  }

  fetchAliada (id) {
    this.props.fetchAliada(id)
  }

  cancelChange (e) {
    const { updatingBooking } = this.props
    if (updatingBooking) {
      e.preventDefault()
    }
  }

  onPenaltyFetched () {
    if (this.state.penaltyFetched === false) {
      this.setState({
        penaltyFetched: true
      })
    }
  }

  getBookingModification () {
    return {
      aliadaId: this.props.replacementAliadaId
    }
  }

  isLoading () {
    const { booking, replacedAliada, replacementAliada } = this.props
    return !booking || !replacedAliada || !replacementAliada
  }

  changeAliadas () {
    const {
      updateBooking,
      bookingId,
      push,
      params: {
        userId
      }
    } = this.props

    const nextUrl = paths.userNextServices(userId)

    const bookingModification = this.getBookingModification()
    updateBooking(bookingId, bookingModification, () => push(nextUrl))
  }

  renderPenalty () {
    // Override this function
  }

  render () {
    const {
      booking,
      bookingTypeId,
      replacedAliada,
      replacementAliada,
      updatingBooking,
      params: {
        userId
      }
    } = this.props

    const {
      penaltyFetched
    } = this.state

    const loading = this.isLoading()
    if (loading) {
      return <div>Loading</div>
    }

    const cancelChangeButtonClassName = cx(
      'ChangeAliadaConfirm-cancelBtn btn btn-default btn-lg btn-block',
      {
        disabled: updatingBooking
      }
    )

    const confirmButtonClassName = cx(
      'ChangeAliadaConfirm-confirmBtn btn btn-primary btn-lg btn-block',
      {
        disabled: updatingBooking || !penaltyFetched
      }
    )

    const bookingModifications = this.getBookingModification()
    const cancelPath = bookingTypeId === serviceTypes.ONE_TIME.id ? paths.userModifyService : paths.userModifyRecurrence

    return (
      <div className='ChangeAliadaConfirm navbar-screen'>
        <ProfileMobileNavBar back>
          {this.navBarLabel}
        </ProfileMobileNavBar>

        <ModifyingServiceLoader
          isOpen={updatingBooking}
          text='Cambiando la Aliada de tu servicio...'
          />

        <div className='ChangeAliadaConfirm-content navbar-screen-content'>
          <div className='ChangeAliadaConfirm-contentCard'>
            <div className='ChangeAliadaConfirm-cardTitle'>
              Confirmar Cambios
            </div>

            <div className='ChangeAliadaConfirm-cardBody'>
              <ChangingAliadasAvatars
                replacedAliada={replacedAliada}
                replacementAliada={replacementAliada}
                />

              <div className='ChangeAliadaConfirm-summary'>
                <ChangeSummary
                  replacedAliada={replacedAliada}
                  replacementAliada={replacementAliada}
                  booking={booking}
                  bookingTypeId={bookingTypeId}
                  />

                {this.renderPenalty({
                  bookingId: booking.id,
                  bookingTypeId: bookingTypeId,
                  bookingModifications: bookingModifications,
                  onPenaltyFetched: this.onPenaltyFetched
                })}

                <p>
                  ¿Estás seguro de que quieres realizar este cambio?
                </p>
              </div>

              <div className='ChangeAliadaConfirm-buttons'>
                <Link
                  className={cancelChangeButtonClassName}
                  to={cancelPath(userId, booking.id)}
                  onClick={this.cancelChange}
                  >
                  Cancelar cambios
                </Link>
                <button
                  className={confirmButtonClassName}
                  onClick={this.changeAliadas}
                  disabled={updatingBooking || !penaltyFetched}
                  >
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ChangeAliadaConfirmBase.displayName = 'ChangeAliadaConfirmBase'
ChangeAliadaConfirmBase.propTypes = {
  bookingTypeId: PropTypes.string.isRequired,
  bookingId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  booking: PropTypes.object,
  fetchingBooking: PropTypes.bool.isRequired,
  updatingBooking: PropTypes.bool.isRequired,
  replacedAliadaId: PropTypes.number,
  replacedAliada: PropTypes.object,
  replacementAliadaId: PropTypes.number,
  replacementAliada: PropTypes.object,
  fetchBooking: PropTypes.func.isRequired,
  updateBooking: PropTypes.func.isRequired,
  fetchAliada: PropTypes.func.isRequired
}
ChangeAliadaConfirmBase.defaultProps = {}

export default ChangeAliadaConfirmBase



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/ChangeAliadaConfirmBase/ChangeAliadaConfirmBase.js